<template>
  <div :class="['sections', sections.containerClass ? sections.containerClass : '', groupWrapperModifier]">
    <div v-if="sections.group && sections.group.label" class="sections__group" :class="sections.group.class">
      <a
        :class="`${linkColorModifier} ${
          sections.group.linkClass ? sections.group.linkClass : 'dea-heading--medium__ml'
        }`"
        class="sections__group-link"
        :href="sections.group.url"
        >{{ sections.group.label }}</a
      >
    </div>
    <div
      v-if="sections.section && sections.section.label"
      class="sections__section-wrapper"
      :class="`${sections.section.class} ${sectionWrapperModifier}`"
    >
      <span class="sections__span-dash dea-heading--regular__m">-</span>
      <div class="sections__section-divider">
        <a
          :class="`${sections.section.linkClass ? sections.section.linkClass : 'dea-heading--regular__m'}`"
          class="sections__section-link"
          :href="sections.section.url"
          >{{ sections.section.label }}</a
        >
        <div v-if="sections.action.label" class="sections__action">
          <Links
            class-name="dea-links dea-links--small dea-grade-check sections__action-link "
            :class="sections.action.class"
            :href="sections.action.url"
          >
            {{ sections.action.label }}
          </Links>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Links from "@/components/elements/Links";

export default {
  name: "SectionArea",

  components: { Links },
  props: {
    sections: {
      type: Object,
      required: true,
    },
  },
  computed: {
    linkColorModifier() {
      if (!this.sections.group.class) return "dea-target-color-blue-docenti";
      return "";
    },
    sectionWrapperModifier() {
      if ((this.sections.action && this.sections.action.label) || this.sections.group.label)
        return "sections__section-wrapper--action";
      return "sections__section-wrapper--no-action";
    },
    groupWrapperModifier() {
      if ((this.sections.action && this.sections.action.label) || this.sections.group.label) return "sections--action";
      return "sections--no-action";
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/system.utils";

.sections {
  @include media("<=s") {
    align-items: flex-start;
    flex-direction: column;
  }

  align-items: center;
  display: flex;
  flex-direction: row;

  &--no-action {
    align-items: flex-end;
    height: $space-intermediate;
  }

  &__group {
    margin: 0 $space-xx-small;

    .sections__group-link {
      @include media("<=s") {
        font-size: $h-font-size-medium;
      }
    }
  }

  &__section-wrapper {
    @include media("<=xs") {
      margin: 0;
    }
    align-items: center;
    display: flex;
    margin: 0 $space-xx-small;

    &--no-action {
      .sections__span-dash {
        line-height: 1;
      }

      transform: translateY(3px);
    }

    .sections__section-link,
    .sections__action-link {
      @include media("<=s") {
        font-size: $h-font-size-xx-small;
      }

      line-height: 1;
    }
  }

  &__span-dash {
    @include media("<=s") {
      display: none;
    }

    margin: 0 $space-xx-small;
  }

  &__section-divider {
    margin-left: $space-xx-small;
  }

  &__action {
    @include media("<=s") {
      display: none;
    }

    margin: 0 $space-xx-small;

    .dea-links__label {
      border-color: inherit;
    }
  }
}
</style>
